<!-- src/views/contact/staff/GraduateChildren.vue -->
<template>
  <div>
    <!-- 查询区域 -->
    <el-form
      :model="queryParams"
      label-position="right"
      label-width="50px"
      style="margin-bottom: 20px"
    >
      <el-row :gutter="20">
        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="年级">
            <el-select
              v-model="queryParams.gradeId"
              placeholder="请选择年级"
              clearable
              style="width: 100%"
            >
              <el-option
                v-for="grade in gradeOptions"
                :key="grade.id"
                :label="grade.name"
                :value="grade.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="班级">
            <el-select
              v-model="queryParams.classId"
              placeholder="请选择班级"
              clearable
              style="width: 100%"
              :disabled="!queryParams.gradeId"
            >
              <el-option
                v-for="classItem in classOptions"
                :key="classItem.id"
                :label="classItem.name"
                :value="classItem.id"
              />
            </el-select>
          </el-form-item>
        </el-col>

        <el-col :xs="24" :sm="12" :md="8" :lg="6">
          <el-form-item label="姓名">
            <el-input
              v-model="queryParams.name"
              placeholder="请输入姓名"
              clearable
              style="width: 100%"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <div>
        <el-button type="primary" icon="el-icon-search" @click="handleQuery(1)">
          搜索
        </el-button>
        <el-button @click="resetQuery">重置</el-button>
      </div>
    </el-form>

    <!-- 表格区域 -->
    <el-table
      :data="tableData"
      style="width: 100%"
      border
      :cell-style="{ textAlign: 'center' }"
      :header-cell-style="{
        background: '#f5f7fa',
        color: '#333',
        fontWeight: 'bold',
        textAlign: 'center',
      }"
    >
      <el-table-column label="姓名" prop="name" />
      <el-table-column label="性别">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column label="出生日期" prop="birthday" />
      <el-table-column label="家长电话" prop="mobile" />
      <el-table-column label="年级" prop="gradeName" />
      <el-table-column label="班级" prop="className" />
      <el-table-column label="MAC" prop="mcn" />
      <el-table-column label="毕业时间" prop="graduateTime" />
      <el-table-column label="操作" width="150">
        <template v-slot="scope">
          <el-button
            type="danger"
            size="mini"
            @click="deleteGraduateChild(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页组件 -->
    <pagination-bar
      :total="total"
      :page-size="pageSize"
      :current-page="currentPage"
      @update:pageSize="pageSize = $event"
      @update:currentPage="currentPage = $event"
      @page-change="handleQuery"
    />
  </div>
</template>

<script>
import { gradeAll, getAllClazzList } from "@/api/repair";
import { childrenList, rolePage, staffDetail } from "@/api/staff.js";
import { MAX_PAGE_SIZE } from "@/utils/const.js";
import { formatTime } from "@/utils/util";
import PaginationBar from "@/components/PaginationBar";

export default {
  components: {
    PaginationBar,
  },
  data() {
    return {
      dialogVisible: false,
      classOptionsForForm: [],
      formData: {
        name: "",
        sex: 1,
        birthday: "",
        gradeId: "",
        classId: "",
        mobile: "",
        mcn: "",
      },
      gradeOptions: [],
      classOptions: [],
      queryParams: {
        gradeId: "",
        classId: "",
        name: "",
      },
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
    };
  },
  created() {
    this.handleQuery();
    this.getAllGrade();
  },
  watch: {
    "queryParams.gradeId": {
      handler(newVal) {
        if (newVal) {
          this.getClassListByGrade(newVal);
        } else {
          this.classOptions = [];
          this.queryParams.classId = "";
        }
      },
    },
    "formData.gradeId": {
      handler(newVal) {
        if (newVal) {
          this.getClassListByGradeForForm(newVal);
        } else {
          this.classOptionsForForm = [];
          this.formData.classId = "";
        }
      },
    },
  },
  methods: {
    getAllGrade() {
      gradeAll().then((res) => {
        this.gradeOptions = res || [];
      });
    },
    getClassListByGrade(gradeId) {
      getAllClazzList({ gradeId }).then((res) => {
        this.classOptions = res || [];
        this.queryParams.classId = "";
      });
    },
    // 删除毕业儿童
    deleteGraduateChild(row) {
      this.$confirm("确定要删除该毕业儿童信息吗？", "删除确认", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          // 这里应该调用实际的删除接口
          // 示例代码，需要替换为实际的API调用
          /*
      staffDelete({ userId: row.id })
        .then(() => {
          this.$message.success('删除成功！');
          this.handleQuery(); // 重新加载数据
        })
        .catch(() => {
          this.$message.error('删除失败！');
        });
      */

          // 模拟删除成功
          this.$message.success("删除成功！");
          this.handleQuery(); // 重新加载数据
        })
        .catch(() => {
          // 用户取消删除
        });
    },
    getClassListByGradeForForm(gradeId) {
      const classData = {
        1: [
          { id: 11, name: "一(1)班" },
          { id: 12, name: "一(2)班" },
          { id: 13, name: "一(3)班" },
        ],
        2: [
          { id: 21, name: "二(1)班" },
          { id: 22, name: "二(2)班" },
          { id: 23, name: "二(3)班" },
        ],
        3: [
          { id: 31, name: "三(1)班" },
          { id: 32, name: "三(2)班" },
          { id: 33, name: "三(3)班" },
        ],
        4: [
          { id: 41, name: "四(1)班" },
          { id: 42, name: "四(2)班" },
          { id: 43, name: "四(3)班" },
        ],
        5: [
          { id: 51, name: "五(1)班" },
          { id: 52, name: "五(2)班" },
          { id: 53, name: "五(3)班" },
        ],
        6: [
          { id: 61, name: "六(1)班" },
          { id: 62, name: "六(2)班" },
          { id: 63, name: "六(3)班" },
        ],
      };

      this.classOptionsForForm = classData[gradeId] || [];
      this.formData.classId = "";
    },
    handleQuery(page) {
      this.currentPage = page || 1;
      const params = {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        ...this.queryParams,
        state: 3, // 1-在读，2-退学，3-毕业
      };
      childrenList(params)
        .then((res) => {
          this.total = res.total;
          this.tableData = res.records;
        })
        .catch((err) => {
          console.error("请求失败：", err);
        });
    },
    resetQuery() {
      this.queryParams = {
        gradeId: "",
        classId: "",
        name: "",
      };
      this.classOptions = [];
      this.currentPage = 1;
      this.handleQuery();
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>

<style scoped>
.custom-dialog >>> .el-dialog {
  margin-top: 20px !important;
  max-height: 90vh;
  overflow-y: auto;
}
</style>
